<div fxLayout="column">
  <mat-progress-bar [value]="progressPercent" [mode]="mode"></mat-progress-bar>
  <div style="padding-top: 1px;">
    @if (mode === 'determinate') {
      <span>{{'m1+2.sprint11.datenpruefen.validation.progress-dialog.content' | translate}} {{progressPercent |
      number:'1.0-0'}}% ({{index}}/{{total}})</span>
    } @else {
      <span translate>m1+2.sprint11.datenpruefen.validation.progress-dialog.transformation</span>
    }
  </div>
</div>

